import { AdminEventJourneyStepDto, AdminEventJourneyStepType } from '@ivy-monorepo/shared'
import { formatEventSource, formatJourneyDate, JOURNEY_STEP_LABELS } from '../utils/eventJourney'

const CONVERSION_STEPS = new Set<AdminEventJourneyStepType>([AdminEventJourneyStepType.Rsvp, AdminEventJourneyStepType.TicketPurchase])

/** One user's steps to an event, oldest first. RSVP / ticket rows are highlighted. */
const EventJourneyTimeline = ({ steps }: { steps: AdminEventJourneyStepDto[] }) => {
  if (steps.length === 0) {
    return <p className="event-journey-empty">No recorded steps.</p>
  }

  return (
    <ol className="event-journey-timeline">
      {steps.map((step, index) => (
        <li key={`${step.type}-${step.at}-${index}`} className={CONVERSION_STEPS.has(step.type) ? 'is-conversion' : undefined}>
          <span className="event-journey-timeline__time">{formatJourneyDate(step.at)}</span>
          <span className="event-journey-timeline__label">
            {JOURNEY_STEP_LABELS[step.type] ?? step.type}
            {step.detail ? ` · ${step.detail}` : ''}
          </span>
          {(step.source || CONVERSION_STEPS.has(step.type) || step.type === AdminEventJourneyStepType.GetTicketsTapped) && (
            <span className="event-journey-timeline__source">from {formatEventSource(step.source)}</span>
          )}
        </li>
      ))}
    </ol>
  )
}

export default EventJourneyTimeline
